import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { FieldArray } from '~src/settings/FormikWrapperForStubbing';

import { DataConnectPoolNodesSectionHeaders } from '../dataConnectPoolNodes/DataConnectPoolNodesSectionHeaders';
import { DataConnectPoolNodesTableRow } from '../dataConnectPoolNodes/DataConnectPoolNodesTableRow';
import { Node } from '../types/Node';
import { PoolID } from '../types/PoolID';
import { multiPoolTableStyle } from './DataConnectMultiPoolSection';

export type MultiPoolTableEntryNodesProps = Readonly<{
  nodes: Node[];
  poolId: PoolID;
  poolName: string;
  clusterId: string;
  siteId: string;
  refreshBaasEdgePools: () => void;
}>;
export const POOL_NODE_FIELD = 'settings.siteAdminBridgeSettings.poolNodeSettings.nodes';

export function DataConnectMultiPoolTableEntryNodes(props: MultiPoolTableEntryNodesProps) {
  const {poolId, poolName, clusterId, siteId} = props;
  return (
    <table className={`${multiPoolTableStyle} tb-static-grid-table-remote-agents-width`}>
      <DataConnectPoolNodesSectionHeaders isDefaultPool={true} />

      <tbody>
        <FieldArray
          name={POOL_NODE_FIELD}
          render={() => (
            props.nodes.length === 0?
            <tr>
              <td colSpan={5}>
                <div className={'tb-data-grid-cell-text tb-data-grid-DataConnect-center'}>
                  { Messages.dataConnectSiteSettingsPoolNodeDefalutRowDescription()}
                </div>
              </td>
            </tr>
          :
            props.nodes.map((node: Node, index: number) => (
              <tr key={index}>
                <DataConnectPoolNodesTableRow
                  node={node}
                  index={index}
                  poolTestId={''}
                  siteId={props.siteId}
                  poolId={poolId}
                  poolName={poolName}
                  clusterId={props.clusterId}
                  refreshBaasEdgePools={props.refreshBaasEdgePools}
                />
              </tr>))
          )}
        />
      </tbody>
    </table>
  );
}
